var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dropdown-playground"},[_c('plain-dropdown',{staticClass:"categories",attrs:{"options":_vm.getOptions,"first-selected":_vm.selected,"on-select":_vm.onSelect}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }